import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  KtMutableList1beimitadwkna as KtMutableList,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  KtList3hktaavzmj137 as KtList,
  KtMap140uvy3s5zad8 as KtMap,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  DeferredFragmentIdentifieryfmj5mbsp1mh as DeferredFragmentIdentifier,
  Companion_getInstance1gsr0g2s69z4f as Companion_getInstance,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/DeferredFragmentIdentifier.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  plus310ted5e4i90h as plus,
  toSet2orjxp16sotqu as toSet,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  nodeAtPath1cd3xt81xpfir as nodeAtPath,
  deepMergeObject115s855ldv6gd as deepMergeObject,
  toJsonMaprsmqd9lb9sfm as toJsonMap,
} from './JsonMap.mjs';
import { plus18eogev54fmsa as plus_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { minus1f3bieyodk5vw as minus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function getOrPutMergedErrors($this) {
  // Inline function 'kotlin.collections.getOrPut' call
  var this_0 = $this.u64_1;
  var value = this_0.u4('errors');
  var tmp;
  if (value == null) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var answer = ArrayList().p2();
    this_0.x4('errors', answer);
    tmp = answer;
  } else {
    tmp = value;
  }
  var tmp_0 = tmp;
  return (!(tmp_0 == null) ? isInterface(tmp_0, KtMutableList()) : false) ? tmp_0 : THROW_CCE();
}
function getOrPutExtensions($this) {
  var tmp0 = $this.u64_1;
  // Inline function 'kotlin.collections.getOrPut' call
  var key = 'extensions';
  var value = tmp0.u4(key);
  var tmp;
  if (value == null) {
    // Inline function 'kotlin.collections.mutableMapOf' call
    var answer = LinkedHashMap().ec();
    tmp0.x4(key, answer);
    tmp = answer;
  } else {
    tmp = value;
  }
  var tmp_0 = tmp;
  return (!(tmp_0 == null) ? isInterface(tmp_0, KtMutableMap()) : false) ? tmp_0 : THROW_CCE();
}
function handlePending($this, part) {
  var tmp = part.u4('pending');
  var pending = (!(tmp == null) ? isInterface(tmp, KtList()) : false) ? tmp : null;
  if (!(pending == null)) {
    var _iterator__ex2g4s = pending.p1();
    while (_iterator__ex2g4s.q1()) {
      var pendingResult = _iterator__ex2g4s.r1();
      var tmp_0 = pendingResult.u4('id');
      var id = (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE();
      var tmp_1 = pendingResult.u4('path');
      var path = (!(tmp_1 == null) ? isInterface(tmp_1, KtList()) : false) ? tmp_1 : THROW_CCE();
      var tmp_2 = pendingResult.u4('label');
      var label = (tmp_2 == null ? true : typeof tmp_2 === 'string') ? tmp_2 : THROW_CCE();
      var tmp0 = $this.w64_1;
      // Inline function 'kotlin.collections.set' call
      var value = new (DeferredFragmentIdentifier())(path, label);
      tmp0.x4(id, value);
    }
  }
}
function handleCompleted($this, completed) {
  if (!(completed == null)) {
    var _iterator__ex2g4s = completed.p1();
    while (_iterator__ex2g4s.q1()) {
      var completedResult = _iterator__ex2g4s.r1();
      var tmp = completedResult.u4('errors');
      var errors = (!(tmp == null) ? isInterface(tmp, KtList()) : false) ? tmp : null;
      if (!(errors == null)) {
        // Inline function 'kotlin.collections.plusAssign' call
        var this_0 = getOrPutMergedErrors($this);
        addAll(this_0, errors);
      } else {
        var tmp_0 = completedResult.u4('id');
        var id = (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE();
        if ($this.w64_1.y4(id) == null) {
          // Inline function 'kotlin.error' call
          var message = "Id '" + id + "' not found in pending results";
          throw IllegalStateException().o(toString(message));
        }
      }
    }
  }
}
function mergeIncrementalResult($this, incrementalResult) {
  var tmp = incrementalResult.u4('id');
  var tmp0_elvis_lhs = (tmp == null ? true : typeof tmp === 'string') ? tmp : THROW_CCE();
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.error' call
    var message = 'No id found in incremental result';
    throw IllegalStateException().o(toString(message));
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var id = tmp_0;
  var tmp_1 = incrementalResult.u4('data');
  var data = (tmp_1 == null ? true : isInterface(tmp_1, KtMap())) ? tmp_1 : THROW_CCE();
  var tmp_2 = incrementalResult.u4('items');
  var items = (tmp_2 == null ? true : isInterface(tmp_2, KtList())) ? tmp_2 : THROW_CCE();
  var tmp_3 = incrementalResult.u4('subPath');
  var tmp1_elvis_lhs = (tmp_3 == null ? true : isInterface(tmp_3, KtList())) ? tmp_3 : THROW_CCE();
  var subPath = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  var tmp2_safe_receiver = $this.w64_1.u4(id);
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.u45_1;
  var tmp_4;
  if (tmp3_elvis_lhs == null) {
    // Inline function 'kotlin.error' call
    var message_0 = "Id '" + id + "' not found in pending results";
    throw IllegalStateException().o(toString(message_0));
  } else {
    tmp_4 = tmp3_elvis_lhs;
  }
  var path = plus(tmp_4, subPath);
  var tmp_5 = $this.v64_1.u4('data');
  var mergedData = (!(tmp_5 == null) ? isInterface(tmp_5, KtMap()) : false) ? tmp_5 : THROW_CCE();
  var nodeToMergeInto = nodeAtPath(mergedData, path);
  if (!(data == null)) {
    deepMergeObject((!(nodeToMergeInto == null) ? isInterface(nodeToMergeInto, KtMutableMap()) : false) ? nodeToMergeInto : THROW_CCE(), data);
  } else if (!(items == null)) {
    mergeList($this, (!(nodeToMergeInto == null) ? isInterface(nodeToMergeInto, KtMutableList()) : false) ? nodeToMergeInto : THROW_CCE(), items);
  } else {
    // Inline function 'kotlin.error' call
    var message_1 = 'Neither data nor items found in incremental result';
    throw IllegalStateException().o(toString(message_1));
  }
}
function mergeList($this, destination, items) {
  destination.u2(items);
}
var V0_2IncrementalResultsMergerClass;
function V0_2IncrementalResultsMerger() {
  if (V0_2IncrementalResultsMergerClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.u64_1 = LinkedHashMap().ec();
        this.v64_1 = this.u64_1;
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_0.w64_1 = LinkedHashMap().ec();
        this.x64_1 = true;
        this.y64_1 = false;
      }
      p64() {
        return plus_0(toSet(this.w64_1.w4()), Companion_getInstance().t45_1);
      }
      q64() {
        return this.x64_1;
      }
      r64() {
        return this.y64_1;
      }
      s64(part) {
        return this.t64(toJsonMap(part));
      }
      t64(part) {
        var tmp = part.u4('completed');
        var completed = (!(tmp == null) ? isInterface(tmp, KtList()) : false) ? tmp : null;
        if (this.v64_1.n1()) {
          var tmp0 = this.u64_1;
          // Inline function 'kotlin.collections.plusAssign' call
          var map = minus(minus(part, 'hasNext'), 'pending');
          tmp0.z4(map);
          handlePending(this, part);
          handleCompleted(this, completed);
          return this.v64_1;
        }
        handlePending(this, part);
        var tmp_0 = part.u4('incremental');
        var incremental = (!(tmp_0 == null) ? isInterface(tmp_0, KtList()) : false) ? tmp_0 : null;
        if (!(incremental == null)) {
          var _iterator__ex2g4s = incremental.p1();
          while (_iterator__ex2g4s.q1()) {
            var incrementalResult = _iterator__ex2g4s.r1();
            mergeIncrementalResult(this, incrementalResult);
            var tmp_1 = incrementalResult.u4('errors');
            var tmp0_safe_receiver = (!(tmp_1 == null) ? isInterface(tmp_1, KtList()) : false) ? tmp_1 : null;
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.collections.plusAssign' call
              var this_0 = getOrPutMergedErrors(this);
              addAll(this_0, tmp0_safe_receiver);
            }
          }
        }
        this.y64_1 = (completed == null && incremental == null);
        var tmp_2 = this;
        var tmp_3 = part.u4('hasNext');
        var tmp1_elvis_lhs = (tmp_3 == null ? true : typeof tmp_3 === 'boolean') ? tmp_3 : THROW_CCE();
        tmp_2.x64_1 = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
        handleCompleted(this, completed);
        var tmp_4 = part.u4('extensions');
        var tmp2_safe_receiver = (!(tmp_4 == null) ? isInterface(tmp_4, KtMap()) : false) ? tmp_4 : null;
        if (tmp2_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.collections.plusAssign' call
          getOrPutExtensions(this).z4(tmp2_safe_receiver);
        }
        return this.v64_1;
      }
      d3o() {
        this.u64_1.a5();
        this.w64_1.a5();
        this.x64_1 = true;
        this.y64_1 = false;
      }
    }
    initMetadataForClass($, 'V0_2IncrementalResultsMerger', V0_2IncrementalResultsMerger);
    V0_2IncrementalResultsMergerClass = $;
  }
  return V0_2IncrementalResultsMergerClass;
}
//region block: exports
export {
  V0_2IncrementalResultsMerger as V0_2IncrementalResultsMerger1xexi65gw211w,
};
//endregion

//# sourceMappingURL=V0_2IncrementalResultsMerger.mjs.map
